export { default as InputLeftAddon } from './InputLeftAddon'
